// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0523919","239":"b253329c","455":"f028538d"}[chunkId] + ".chunk.js";
};